import React from 'react';
import type PlanReleasesType from '@jira/spa-apps__advanced-roadmaps-plan-releases/src/PlanReleases.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/main/tabs/releases/types.tsx';

/**
 * Plan Releases page
 */

export const LazyPlanReleases: LazyComponent<({ store, ...props }: Props) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanReleasesType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-releases", jiraSpaEntry: "async-plan-releases" */ '@jira/spa-apps__advanced-roadmaps-plan-releases/src/PlanReleases.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanReleases = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanReleases} pageId="plan-releases" shouldShowSpinner />
);

export default AsyncPlanReleases;
